import getKeyboardShortcutsOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('selectShortcutsOption', function selectShortcutsOption(shortcutSet) {
    var optionState = getKeyboardShortcutsOptions();
    optionState.shortcuts = shortcutSet;
});
//# sourceMappingURL=selectShortcutsOption.js.map